// extracted by mini-css-extract-plugin
var _1 = "EDqj7TQE9w";
var _2 = "pRbzd9uGeu";
var _3 = "zVaiWEa2c3";
var _4 = "Fnp_9coFRK";
export { _1 as "anonymous", _2 as "avatar", _3 as "name", _4 as "root" }
